import { SplitFactory } from '@splitsoftware/splitio';
import * as Constants from './constants';
import {
    Treatments,
    MockedFeaturesMap,
} from '@splitsoftware/splitio/types/splitio';

export const makeFlagList = function(
    flagsConfiguration: Object = Constants.flags
) {
    return Object.values(flagsConfiguration);
};

export const getSplitAuthorizationKey = () => {
    return process.env.REACT_APP_SPLIT_AUTH_KEY || 'localhost';
};

export const isSplitDebugMode = () => {
    switch (process.env.ENV) {
        default:
            return false;
    }
};

export const isSplitLocalMode = () => {
    switch (process.env.ENV) {
        case 'production':
        case 'staging':
            return false;
        default:
            return true;
    }
};

export const getSplitMockFeatures = (
    isSplitDebugMode: boolean = false
): MockedFeaturesMap => {
    return isSplitLocalMode() ? Constants.localhostTreatments : {};
};

export const makeSplitConfigObject = (customerEmailAddress: string) => {
    // see split docs: https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#configuration`
    return {
        startup: {
            requestTimeoutBeforeReady: 5,
            retriesOnFailureBeforeReady: 1,
            readyTimeout: 5,
            eventsFirstPushWindow: 10,
        },
        core: {
            authorizationKey: getSplitAuthorizationKey(),
            key: customerEmailAddress,
            trafficType: 'user',
            labelsEnabled: true,
        },
        scheduler: {
            featuresRefreshRate: 30,
            segmentsRefreshRate: 60,
            metricsRefreshRate: 60,
            impressionsRefreshRate: 60,
            eventsPushRate: 60,
            eventsQueueSize: 500,
            offlineRefreshRate: 30000,
        },
        storage: {
            //    type: 'LOCALSTORAGE',
        },
        debug: isSplitDebugMode(),
        features: getSplitMockFeatures(),
    };
};
